module.exports = __webpack_public_path__ + "static/media/buildingConstruction17.2ee4c6af.jpeg";